var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-link',{staticClass:"submenu-link",class:{
		'btn-link': _vm.isLinkTypeButton,
		'active-route': _vm.isCurrentRoute
	},attrs:{"to":_vm.item.to,"params":{ param: _vm.item.param }}},[_c('base-font',{staticClass:"submenu-title",class:{
			'bold': _vm.isMoreManufacturers
		},attrs:{"variant":"menu"}},[_vm._v(" "+_vm._s(_vm.item.name)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }